"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./Link.scss");
var BaseCta_1 = require("../BaseCta");
var LinkProps_1 = require("./LinkProps");
var Simplify_1 = require("../../../helpers/Functions/Simplify");
/**
 * A CTA that looks like a link. Will use `<a>` or `<button>` under the hood depending on the functionality needed.
 */
var Link = BaseCta_1.MakeCtaFromBase(function (allProps) {
    var _a = Simplify_1.simplify(allProps), _b = _a.kind, kind = _b === void 0 ? "utilityPrimary" : _b, icon = _a.icon, props = __rest(_a, ["kind", "icon"]);
    return {
        prepend: kind === "withPrependIcon" ? icon : "",
        append: kind === "withAppendIcon" ? icon : "",
        classes: [
            LinkProps_1.Kind[kind],
            kind === "withPrependIcon" || kind === "withAppendIcon"
                ? allProps.onDark
                    ? "line-h-md color-ui-white font-medium"
                    : "line-h-md color-cobalt font-medium"
                : "",
        ],
        props: __assign(__assign({}, props), { className: allProps.className, overrideLink: true, role: allProps.role ? allProps.role : undefined }),
    };
});
exports.default = Link;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Link/Link.js
// module id = 1651
// module chunks = 8